import dayjs from 'dayjs'
import { QueryListFilter } from '@feedyou-ai/feedbot-schema'

export type Preset = '0' | '1' | '3' | '7' | '14' | '30' | '90' | 'custom'

export function getPresetOptionForDateTimeFilter(filter: QueryListFilter): Preset {
  const dateTo = dayjs(Number(filter.toTimestamp))
  const dateFrom = dayjs(Number(filter.fromTimestamp))

  if (!dateTo.isValid() || !dateFrom.isValid()) {
    return '0'
  }

  const customOption: Extract<Preset, 'custom'> = 'custom'
  const pastDaysBackOptions: Exclude<Preset, 'custom'>[] = ['0', '1', '3', '7', '14', '30', '90']

  // note: minus one is here because of the dateTo border, which is startOf (00:00) next day and not endOf this day (23:59)
  const daysDiff = (dateTo.diff(dateFrom, 'days') - 1).toString() as Exclude<Preset, 'custom'>
  const daysBack = daysDiff === '0' && dayjs().startOf('days').isSame(dateTo) ? '1' : daysDiff

  if (!pastDaysBackOptions.includes(daysBack)) {
    return customOption
  }

  if (!dateFrom.startOf('days').isSame(dateFrom)) {
    return customOption
  }

  const isYesterdayOption = daysBack === '1'
  // note: exception for yesterday option, which is how the user perceives the yesterday option
  if (isYesterdayOption && !dayjs().startOf('days').isSame(dateTo)) {
    return customOption
  }

  if (!isYesterdayOption && !dayjs().add(1, 'days').startOf('days').isSame(dateTo)) {
    return customOption
  }

  return daysBack
}
